import * as angular from "angular";
import {CommonsService} from "../commons/services/commons-service.service";
import {ViewSettingsService} from "../commons/services/view-settings-service.service";
import {ServicesViewsStateType} from "../deliveries/types/services-views-state.type";
import {ViewSettingsHolderType, ViewSettingsType} from "../commons/models/view-settings.model";
import {PlanningTemplateDefaultDraftService} from "./services/planning-template-default-draft.service";
import {PlanningTemplateDefaultDraftRequestsService} from "./services/planning-template-default-draft-requests.service";

angular
  .module('bringoz.admin.planning')
  .config(planningConfig);

/* @ngInject */
function planningConfig($stateProvider) {

  $stateProvider


    .state('planning', {
      parent: 'bringoz.site',
      abstract: true,
      url: '/planning',
      template: '<ui-view></ui-view>',
      controller: function (site) {
      }
    })

    // Projects View
    .state('planning.projects', {
      url: '/projects',
      controllerAs: 'vm',
      abstract: true,
      template: '<planning-projects-view></planning-projects-view>'
    })

    // Projects View
    .state('planning.projects.scheduled', {
      url: '/scheduled?:branchIds',
      controllerAs: 'vm',
      abstract: true,
      template: '<planning-projects-scheduled-view projects="vm.projects" branch-ids="vm.branchIds"></planning-projects-scheduled-view>',
      controller: function ($stateParams, commonsService: CommonsService, site) {
        this.projects = [];
        this.branchIds = $stateParams.branchIds ? commonsService.parseArrayStateParam($stateParams.branchIds) : [];

      }
    })

    // Projects View - Calendar
    .state('planning.projects.scheduled.calendar', {
      url: '/calendar',
      controllerAs: 'vm',
      template: '<planning-projects-calendar-view projects="$ctrl.projects" '
        + 'on-range-change="$ctrl.onRangeChange(from, to)" '
        + 'on-delete-project="$ctrl.onDeleteProject(project)" '
        + 'from="$ctrl.from" to="$ctrl.to"></planning-projects-calendar-view>',
      controller: function (triBreadcrumbsService) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Calendar"});
        triBreadcrumbsService.addCrumb({name: "Projects Schedule"});
        triBreadcrumbsService.addCrumb({name: "Planning"});
      }
    })

    // Projects View - Table
    .state('planning.projects.scheduled.table', {
      url: '/table',
      controllerAs: 'vm',
      template: '<planning-projects-table-view branch-ids="$ctrl.branchIds"></planning-projects-table-view>',
      controller: function (triBreadcrumbsService) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Table"});
        triBreadcrumbsService.addCrumb({name: "Projects Schedule"});
        triBreadcrumbsService.addCrumb({name: "Planning"});
      }
    })

    // Projects View - Templates
    .state('planning.projects.templates', {
      url: '/templates',
      controllerAs: 'vm',
      template: '<planning-templates-view templates="vm.templates"</planning-projects-templates-view>',
      controller: function (templates, triBreadcrumbsService) {

        this.templates = templates;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Templates"});
        triBreadcrumbsService.addCrumb({name: "Planning"});
      },
      resolve: {
        templates: function (planningRequestsService, site) {
          return planningRequestsService.getTemplates();
        }
      }
    })

    // Projects View - Default Drafts
    .state('planning.projects.default-drafts', {
      url: '/default-drafts',
      controllerAs: 'vm',
      template: '<planning-default-drafts-view></planning-default-drafts-view>',
      controller: function (triBreadcrumbsService) {
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Default Drafts'});
        triBreadcrumbsService.addCrumb({name: 'Planning'});
      },
      resolve: {}
    })


    // Projects View - Templates
    .state('planning.projects.reports', {
      url: '/reports',
      controllerAs: 'vm',
      template: '<planning-reports-view></planning-reports-view>',
      controller: function (triBreadcrumbsService) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Reports"});
        triBreadcrumbsService.addCrumb({name: "Planning"});
      }
    })


    // // Project - Abstract View
    .state('planning.project-old', {
      url: '/projects-old/:projectId',
      controllerAs: 'vm',
      template: '<ui-view></ui-view>',
      controller: function (project, planningConstants, $state) {
        const currentState = $state.current.name;

        // Project Statuses - SCHEME/IMPORT/RUNNING/COMPLETED/DISPATCHED
        if (currentState !== planningConstants.states.completedOld &&
          currentState !== planningConstants.states.routesOld &&
          project.status === 'DISPATCHED') {
          $state.go(planningConstants.states.completedOld, {}, {notify: true, reload: false, location: 'replace'})
        }
      },
      resolve: {
        project: function (planningRequestsService, $stateParams, site) {
          return planningRequestsService.getProject($stateParams.projectId);
        }
      }
    })

    // Project - Scheme Views
    .state('planning.project-old.scheme', {
      url: '/scheme?:draftId',
      controllerAs: 'vm',
      template: '<planning-project-scheme-view project="vm.project" status="vm.project.status" draft-ids="vm.project.draftsIds" selected-tab="vm.selectedTab"></planning-project-scheme-view>',
      controller: function (project, $planningProjects, $scope, $state, $stateParams) {
        const vm = this;

        vm.project = project;
        vm.selectedTab = $stateParams.draftId || 'PROJECT';

        $planningProjects(project.id).$bindCtrl($scope, vm, 'project');
      },
      resolve: {
        depots: function (planningProjectsService, $stateParams, project, site) {
          return planningProjectsService.getDepots(project.id);
        }
      }
    })

    // Project - Scheme Views - Project View
    .state('planning.project-old.scheme.project', {
      url: '/project',
      controllerAs: 'vm',
      template: '<planning-project-view project="$ctrl.project" jobs="vm.jobs" resources="vm.resources" depots="vm.depots" draft-template="vm.draftTemplate" project-template="vm.projectTemplate"></planning-project-view>',
      controller: function (project, jobs, resources, depots, draftTemplate, projectTemplate, $state, planningConstants, triBreadcrumbsService, $filter) {

        // this.project = project;
        this.jobs = jobs;
        this.resources = resources;
        this.depots = depots;
        this.draftTemplate = draftTemplate;
        this.projectTemplate = projectTemplate;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({
          name: project.name + ' ' + $filter('bringozDateRange')(project, true, true),
          ignoreTranslate: true
        });
        triBreadcrumbsService.addCrumb({name: 'Projects Schedule', state: planningConstants.states.projectsCalendar});
        triBreadcrumbsService.addCrumb({name: "Planning"});
      },
      resolve: {
        jobs: function (planningProjectsService, $stateParams, project, site) {
          return planningProjectsService.getJobs(project.id);
        },
        resources: function (planningProjectsService, $stateParams, project, site) {
          return planningProjectsService.getResources(project.id);
        },
        draftTemplate: function (planningTemplateDefaultDraftRequestsService: PlanningTemplateDefaultDraftRequestsService, project, site) {
          if (!!project.draftTemplateId) {
            return planningTemplateDefaultDraftRequestsService.getDefaultDraftTemplate(project.draftTemplateId)
          }
        },
        projectTemplate: function (planningRequestsService, project, site) {
          if (!!project.projectTemplateId) {
            return planningRequestsService.getTemplate(project.projectTemplateId);
          }
        }
      }
    })

    // Project - Scheme Views - Draft View
    .state('planning.project-old.scheme.draft', {
      url: '/draft',
      // url: '/draft/:draftId',
      controllerAs: 'vm',
      template: '<planning-project-draft-view project="$ctrl.project" draft="vm.draft" routes="vm.routes" ' +
        'analysis="vm.analysis" jobs="vm.jobs" depots="vm.depots"></planning-project-draft-view>',
      controller: function (project, draft, jobs, depots, $state, planningConstants, triBreadcrumbsService, $filter) {


        // this.project = project;
        this.draft = draft;
        // this.analysis = analysis;
        // this.routes = routes;
        this.jobs = jobs;
        // this.resources = resources;
        this.depots = depots;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({
          name: project.name + ' ' + $filter('bringozDateRange')(project, true, true),
          ignoreTranslate: true
        });
        triBreadcrumbsService.addCrumb({name: 'Projects Schedule', state: planningConstants.states.projectsCalendar});
        triBreadcrumbsService.addCrumb({name: "Planning"});
      },
      resolve: {
        draft: function (planningDraftsService, $stateParams, project, site) {
          return planningDraftsService.getDraft($stateParams.draftId, project.id);
        },
        // analysis: function(PlanningDraftsService, $stateParams, project, site) {
        //    return PlanningDraftsService.getDraftAnalysis($stateParams.draftId);
        // },
        // routes: function(PlanningDraftsService, $stateParams, project, site) {
        //    return PlanningDraftsService.getRoutes(project.id, $stateParams.draftId);
        // },
        jobs: function (planningDraftsService, $stateParams, project, site) {
          return planningDraftsService.getJobs(project.id, $stateParams.draftId);
        }
        // resources: function(PlanningDraftsService, $stateParams, project, site) {
        //    return PlanningDraftsService.getResources(project.id, $stateParams.draftId);
        // },
      }
    })

    // Project - Completed View
    .state('planning.project-old.completed', {
      url: '/dispatched?:draftId',
      controllerAs: 'vm',
      template: '<planning-project-completed-view project="vm.project" draft="vm.draft" analysis="vm.analysis" jobs="vm.jobs" routes="vm.routes"></planning-project-completed-view>',
      controller: function (project, draft, analysis, jobs, routes, $state, $filter, planningConstants, triBreadcrumbsService) {

        this.project = project;
        this.draft = draft;
        this.analysis = analysis;
        this.routes = routes;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({
          name: project.name + ' ' + $filter('translate')('Dispatched'),
          ignoreTranslate: true
        });
        triBreadcrumbsService.addCrumb({name: 'Projects Schedule', state: planningConstants.states.projectsCalendar});
        triBreadcrumbsService.addCrumb({name: "Planning"});
      },
      resolve: {
        draft: function (planningDraftsService, $stateParams, project, site) {
          const selectedDraftId = $stateParams.draftId || project.selectedDraftId;
          return planningDraftsService.getDraft(selectedDraftId, project.id);
        },
        analysis: function (planningDraftsService, $stateParams, project, site) {
          const selectedDraftId = $stateParams.draftId || project.selectedDraftId;
          return planningDraftsService.getDraftAnalysis(selectedDraftId);
        },
        jobs: function (planningDraftsService, $stateParams, project, site) {
          const selectedDraftId = $stateParams.draftId || project.selectedDraftId;
          return planningDraftsService.getJobs(project.id, selectedDraftId);
        },
        routes: function (planningDraftsService, $stateParams, project, site) {
          const selectedDraftId = $stateParams.draftId || project.selectedDraftId;
          return planningDraftsService.getRoutes(project.id, selectedDraftId);
        },
        // draftAndAnalysis: function(PlanningDraftsService, $stateParams, project, site) {
        //    var selectedDraftId = $stateParams.draftId || project.selectedDraftId;
        //    return PlanningDraftsService.getDraftWithAnalysis(selectedDraftId, project.id);
        // }
      }
    })

    // Project - Routes View
    .state('planning.project-old.routes', {
      url: '/routes?:draftId',
      controllerAs: 'vm',
      template: '<planning-routes project="vm.project"></planning-routes>',
      controller: function (project, draft, $state, routesService, planningConstants, triBreadcrumbsService) {

        this.project = project;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: project.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Projects Schedule', state: planningConstants.states.projectsCalendar});
        triBreadcrumbsService.addCrumb({name: "Planning"});
      },
      resolve: {
        draft: function (planningDraftsService, $stateParams, project, site) {
          return planningDraftsService.getDraft($stateParams.draftId, project.id);
        }
      }
    })
    // Project - Abstract View
    .state('planning.project', {
      url: '/projects/:projectId',
      controllerAs: 'mainVm',
      template: '<ui-view></ui-view>',
      controller: function (project, $planningProjects, $scope, planningConstants, $state) {
        const currentState = $state.current.name;


        this.project = project;
        // Project Statuses - SCHEME/IMPORT/RUNNING/COMPLETED/DISPATCHED
        if (currentState !== planningConstants.states.completed &&
          currentState !== planningConstants.states.routes &&
          project.status === 'DISPATCHED') {
          $state.go(planningConstants.states.completed, {}, {notify: true, reload: false, location: 'replace'})
        } else {
          $planningProjects(project.id).$bindCtrl($scope, this, 'project');
        }

      },
      resolve: {
        project: function (planningRequestsService, $stateParams, site) {
          return planningRequestsService.getProject($stateParams.projectId);
        }
      }
    })

    // Project - Scheme Views
    // .state('planning.project.scheme', {
    //   url: '/scheme?:draftId',
    //   controllerAs: 'vm',
    //   template: '<planning-project-scheme-view-new project="vm.project" status="vm.project.status" draft-ids="vm.project.draftsIds" selected-tab="vm.selectedTab"></planning-project-scheme-view-new>',
    //   controller: function(project, $planningProjects, $scope, $state, $stateParams) {
    //     const vm = this;
    //
    //     vm.project = project;
    //     vm.selectedTab = $stateParams.draftId || 'PROJECT';
    //
    //     $planningProjects(project.id).$bindCtrl($scope, vm, 'project');
    //   },
    //   resolve: {
    //     depots: function(planningProjectsService, $stateParams, project, site) {
    //       return planningProjectsService.getDepots(project.id);
    //     }
    //   }
    // })

    // Project - Scheme Views - Project View
    .state('planning.project.project', {
      url: '/project',
      controllerAs: 'vm',
      template: '<planning-project-view-new project="mainVm.project" jobs="vm.jobs" draft-template="vm.draftTemplate" project-template="vm.projectTemplate" project-status="mainVm.project.status" ' +
        'resources="vm.resources" view-settings="vm.viewTableSettings"></planning-project-view-new>',
      controller: function (project, jobs, draftTemplate, projectTemplate, resources, $state, viewTableSettings, planningConstants, triBreadcrumbsService, $filter) {

        // this.project = project;
        this.jobs = jobs;
        this.resources = resources;
        this.draftTemplate = draftTemplate;
        this.projectTemplate = projectTemplate;

        this.viewTableSettings = viewTableSettings?.reverse().find(v => v.holderType === ViewSettingsHolderType.User);

      },
      resolve: {
        jobs: function (planningProjectsService, $stateParams, project, site) {
          return planningProjectsService.getJobs(project.id);
        },
        resources: function (planningProjectsService, $stateParams, project, site) {
          return planningProjectsService.getResources(project.id);
        },
        viewTableSettings: function (viewSettingsService: ViewSettingsService, project, site) {
          return viewSettingsService.getByUser('planning.draft', ViewSettingsType.ViewTable);
        },
        draftTemplate: function (planningTemplateDefaultDraftRequestsService: PlanningTemplateDefaultDraftRequestsService, project, site) {
          if (!!project.draftTemplateId && !project.snapshot) {
            return planningTemplateDefaultDraftRequestsService.getDefaultDraftTemplate(project.draftTemplateId)
          }
        },
        projectTemplate: function (planningRequestsService, project, site) {
          if (!!project.projectTemplateId && !project.snapshot) {
            return planningRequestsService.getTemplate(project.projectTemplateId);
          }
        }
      }
    })

    // Project - Scheme Views - Draft View
    .state('planning.project.draft', {
      url: '/draft?:draftId',
      // url: '/draft/:draftId',
      controllerAs: 'vm',
      template: '<planning-project-draft-view-new project="mainVm.project" project-status="mainVm.project.status"' +
        ' draft="vm.draft" ' +
        'analysis="vm.analysis" view-settings="vm.viewTableSettings" view-settings-columns="vm.viewSettingsColumns"></planning-project-draft-view-new>',
      controller: function (project, draft, $state, $stateParams, viewTableSettings, viewSettingsColumns) {

        this.selectedTab = $stateParams.draftId || 'PROJECT';

        // this.project = project;
        this.draft = draft;

        this.viewTableSettings = viewTableSettings
          ?.filter(item => item.holderType === ViewSettingsHolderType.User)
          ?.reduce((latest, current) => {
            if (!latest || current.updatedAt > latest.updatedAt) {
              return current;
            }
            return latest;
          }, undefined as typeof viewTableSettings[number] | undefined);

        this.viewSettingsColumns = viewSettingsColumns
          ?.filter(item => item.holderType === ViewSettingsHolderType.User)
          ?.reduce((latest, current) => {
            if (!latest || current.updatedAt > latest.updatedAt) {
              return current;
            }
            return latest;
          }, undefined as typeof viewTableSettings[number] | undefined);

        // this.viewTableSettings = viewTableSettings?.reverse().find(v => v.holderType === ViewSettingsHolderType.User);
        // this.viewSettingsColumns = viewSettingsColumns?.reverse().find(v => v.holderType === ViewSettingsHolderType.User);

      },
      resolve: {
        draft: function (planningDraftsService, $stateParams, project, site) {
          return planningDraftsService.getDraft($stateParams.draftId, project.id);
        },
        // analysis: function(PlanningDraftsService, $stateParams, project, site) {
        //    return PlanningDraftsService.getDraftAnalysis($stateParams.draftId);
        // },
        // routes: function(PlanningDraftsService, $stateParams, project, site) {
        //    return PlanningDraftsService.getRoutes(project.id, $stateParams.draftId);
        // },
        viewTableSettings: function (viewSettingsService: ViewSettingsService, $stateParams, site) {
          return viewSettingsService.getByUser(`planning.draft-${$stateParams.draftId}`, ViewSettingsType.DraftPanels);
        },
        viewSettingsColumns: function (viewSettingsService: ViewSettingsService, $stateParams, site) {
          return viewSettingsService.getByUser(`planning.project`, ViewSettingsType.DraftPanels);
        }
        // resources: function(PlanningDraftsService, $stateParams, project, site) {
        //    return PlanningDraftsService.getResources(project.id, $stateParams.draftId);
        // },
      }
    })

    // Project - Completed View
    .state('planning.project.completed', {
      url: '/dispatched?:draftId',
      controllerAs: 'vm',
      template: '<planning-project-completed-view project="vm.project" draft="vm.draft" analysis="vm.analysis" jobs="vm.jobs" routes="vm.routes"></planning-project-completed-view>',
      controller: function (project, draft, analysis, jobs, routes, $state, $filter, planningConstants, triBreadcrumbsService) {

        this.project = project;
        this.draft = draft;
        this.analysis = analysis;
        this.routes = routes;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({
          name: project.name + ' ' + $filter('translate')('Dispatched'),
          ignoreTranslate: true
        });
        triBreadcrumbsService.addCrumb({name: 'Projects Schedule', state: planningConstants.states.projectsCalendar});
        triBreadcrumbsService.addCrumb({name: "Planning"});
      },
      resolve: {
        draft: function (planningDraftsService, $stateParams, project, site) {
          const selectedDraftId = $stateParams.draftId || project.selectedDraftId;
          return planningDraftsService.getDraft(selectedDraftId, project.id);
        },
        analysis: function (planningDraftsService, $stateParams, project, site) {
          const selectedDraftId = $stateParams.draftId || project.selectedDraftId;
          return planningDraftsService.getDraftAnalysis(selectedDraftId);
        },
        jobs: function (planningDraftsService, $stateParams, project, site) {
          const selectedDraftId = $stateParams.draftId || project.selectedDraftId;
          return planningDraftsService.getJobs(project.id, selectedDraftId);
        },
        routes: function (planningDraftsService, $stateParams, project, site) {
          const selectedDraftId = $stateParams.draftId || project.selectedDraftId;
          return planningDraftsService.getRoutes(project.id, selectedDraftId);
        },
        // draftAndAnalysis: function(PlanningDraftsService, $stateParams, project, site) {
        //    var selectedDraftId = $stateParams.draftId || project.selectedDraftId;
        //    return PlanningDraftsService.getDraftWithAnalysis(selectedDraftId, project.id);
        // }
      }
    })

    // Project - Routes View
    .state('planning.project.routes', {
      url: '/routes?:draftId',
      controllerAs: 'vm',
      template: '<planning-routes project="vm.project"></planning-routes>',
      controller: function (project, draft, $state, routesService, planningConstants, triBreadcrumbsService) {

        this.project = project;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: project.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Projects Schedule', state: planningConstants.states.projectsCalendar});
        triBreadcrumbsService.addCrumb({name: "Planning"});
      },
      resolve: {
        draft: function (planningDraftsService, $stateParams, project, site) {
          return planningDraftsService.getDraft($stateParams.draftId, project.id);
        }
      }
    })

    // Template - Detail View
    .state('planning.template', {
      url: '/templates/:id',
      controllerAs: 'vm',
      template: '<planning-template-view template="vm.template"></planning-template-view>',
      controller: function (template, planningConstants, $state, triBreadcrumbsService) {

        this.template = template;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: template.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Templates', state: planningConstants.states.templates});
        triBreadcrumbsService.addCrumb({name: 'Planning'});
      },
      resolve: {
        template: function (planningRequestsService, $stateParams, site) {
          return planningRequestsService.getTemplate($stateParams.id);
        }
      }
    })


}
